/*
 * @Author: jiyuhang
 * @LastEditors: jiyuhang
 * @Date: 2021-12-09 15:10:03
 * @LastEditTime: 2022-03-02 10:57:24
 * @FilePath: /inspector-m/src/views/userAuthorization/router.js
 */
// http://wiki.renrenaiche.cn/pages/viewpage.action?pageId=41665335
export default { // 该需求运行在浏览器中
  tabs: [
    {
      name: 'UserAuthorization',
      path: '/userConfirm/userAuthorization',
      component: () => import('./src/UserAuthorization'),
      meta: {
        title: '用户授权页面',
        openNetwork: true
      }
    }
  ]
}
